import { ReducerCreators } from '@reduxjs/toolkit';

import { ChannelSettingsState } from '../types';
import getProjectAlertEmailsReducer from './get-project-alert-emails-reducer';
import updateProjectAlertEmailsReducer from './update-project-alert-emails-reducer';
import updateBccEmailsReducer from './update-bcc-emails-reducer';
import getRedirectsReducer from './get-redirects-reducer';
import deleteRedirectReducer from './delete-redirect-reducer';
import updateRedirectReducer from './update-redirect-reducer';
import createRedirectReducer from './create-redirect-reducer';
import getBccEmailsReducer from './get-bcc-emails-reducer';
import setShowEditChannelDetailsModalReducer from './set-show-edit-channel-details-modal-reducer';
import setShowEditPrimaryContactModalReducer from './set-show-edit-primary-contact-modal-reducer';
import setShowEditEmailSettingsModalReducer from './set-show-edit-email-settings-modal-reducer';
import setShowRedirectModalReducer from './set-show-redirect-modal-reducer';
import getApiKeysReducer from './get-api-keys-reducer';
import createApiKeyReducer from './create-api-key-reducer';
import deactivateApiKeyReducer from './deactivate-api-key-reducer';
import fetchChannelInstancesReducer from './fetch-channel-instances-reducer';
import fetchTrayUserReducer from './fetch-tray-user-reducer';
import fetchSolutionsReducer from './fetch-solutions-reducer';
import fetchSolutionInstancesReducer from './fetch-solution-instances-reducer';
import toggleSolutionInstanceReducer from './toggle-solution-instance-reducer';
import createSolutionInstanceReducer from './create-solution-instance-reducer';
import clearInstanceToCreateReducer from './clear-instance-to-create-reducer';
import fetchOauthIntegrationReducer from './fetch-oauth-integration-reducer';
import toggleOauthIntegrationAdminUseReducer from './toggle-oauth-integration-admin-use-reducer';
import toggleOauthIntegrationReducer from './toggle-oauth-integration-reducer';
import createOauthIntegrationReducer from './create-oauth-integration-reducer';
import updateOauthIntegrationReducer from './update-oauth-integration-reducer';
import fetchStripeIntegrationReducer from './fetch-stripe-integration-reducer';
import setStripeContactReducer from './set-stripe-contact-reducer';
import setShowStripeModalReducer from './set-show-stripe-modal-reducer';
import setShowUpsertIntegrationModalReducer from './set-show-upsert-integration-modal-reducer';
import setShowSelectIntegrationModalReducer from './set-show-select-integration-modal-reducer';
import setIntegrationNameToAddReducer from './set-integration-name-to-add-reducer';
import setShowHiveModalReducer from './set-show-hive-modal-reducer';
import setShowKollectiveModalReducer from './set-show-kollective-modal-reducer';
import setInboundIntegrationToEditReducer from './set-inbound-integration-to-edit-reducer';

export const reducers = (create: ReducerCreators<ChannelSettingsState>) => ({
  getProjectAlertEmails: getProjectAlertEmailsReducer(create),
  updateProjectAlertEmails: updateProjectAlertEmailsReducer(create),
  updateBccEmails: updateBccEmailsReducer(create),
  getRedirects: getRedirectsReducer(create),
  deleteRedirect: deleteRedirectReducer(create),
  updateRedirect: updateRedirectReducer(create),
  createRedirect: createRedirectReducer(create),
  getBccEmails: getBccEmailsReducer(create),
  setShowEditChannelDetailsModal: setShowEditChannelDetailsModalReducer(create),
  setShowEditPrimaryContactModal: setShowEditPrimaryContactModalReducer(create),
  setShowEditEmailSettingsModal: setShowEditEmailSettingsModalReducer(create),
  setShowRedirectModal: setShowRedirectModalReducer(create),
  getApiKeys: getApiKeysReducer(create),
  createApiKey: createApiKeyReducer(create),
  deactivateApiKey: deactivateApiKeyReducer(create),
  fetchChannelInstances: fetchChannelInstancesReducer(create),
  fetchTrayUser: fetchTrayUserReducer(create),
  fetchSolutions: fetchSolutionsReducer(create),
  fetchSolutionInstances: fetchSolutionInstancesReducer(create),
  toggleSolutionInstance: toggleSolutionInstanceReducer(create),
  createSolutionInstance: createSolutionInstanceReducer(create),
  clearInstanceToCreate: clearInstanceToCreateReducer(create),
  fetchOauthIntegration: fetchOauthIntegrationReducer(create),
  toggleOAuthIntegrationAdminUse: toggleOauthIntegrationAdminUseReducer(create),
  toggleOAuthIntegration: toggleOauthIntegrationReducer(create),
  createOAuthIntegration: createOauthIntegrationReducer(create),
  updateOAuthIntegration: updateOauthIntegrationReducer(create),
  fetchStripeIntegration: fetchStripeIntegrationReducer(create),
  setStripeContact: setStripeContactReducer(create),
  setShowStripeModal: setShowStripeModalReducer(create),
  setShowUpsertIntegrationModal: setShowUpsertIntegrationModalReducer(create),
  setShowSelectIntegrationModal: setShowSelectIntegrationModalReducer(create),
  setIntegrationNameToAdd: setIntegrationNameToAddReducer(create),
  setShowHiveModal: setShowHiveModalReducer(create),
  setShowKollectiveModal: setShowKollectiveModalReducer(create),
  setInboundIntegrationToEdit: setInboundIntegrationToEditReducer(create),
});
